import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import * as fromActions from 'store/actions/general.action'
import { Actions as GeneralActions } from 'store/actions/general.action'

interface MyProps {}

const AdminCoursesWrapper: React.FC = (
  props: React.PropsWithChildren<MyProps>
) => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fromActions.Actions.get())
    dispatch(GeneralActions.getIntegrationsList())
  }, [dispatch])

  return <>{props.children}</>
}
export default AdminCoursesWrapper
